import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-rc-entreprise',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent, RouterModule],
  templateUrl: './assurance-rc-entreprise.component.html',
  styleUrl: './assurance-rc-entreprise.component.scss'
})
export class AssuranceRcEntrepriseComponent implements OnInit {
  title = 'Assurance Responsabilité Civile';
  subtitle = '';
  phoneNumber = '01 42 27 12 43';
  heroImage = 'assets/static_pages_images/rc.jpg';
  
  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Responsabilité Civile', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance de l\'Activité des Professionnels et Entreprises',
    link: '/assurance-activite-professionnels'
  };

  nextPage = { 
    title: 'Assurance Responsabilité Civile Mandataires Sociaux',
    link: '/assurance-rc-mandataires-sociaux'
  };

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
